import { useState } from 'react';
import Image from 'next/image';

import getImgSrcWorkaround, { getImgData } from '@/utils/images';
import { Quote, SectionHeader, SectionWrap } from '@swordhealth/ui-corporate';

import { ImagesContainer, ImagesWrapper, CustomSlider, GradientCircle } from './styles';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/a11y';

export default function ImageQuoteCarousel({ content }) {
  const { titles, testimonialItem } = content;
  const [currentIndex, setCurrentIndex] = useState(1);

  return (
    <SectionWrap theme={null} paddingBottom={false} as="div">
      <SectionHeader {...titles} label={titles?.upperLabel} />
      <SectionWrap as="div" theme={null} paddingBottom={false}>
        <ImagesContainer>
          <ImagesWrapper>
            {testimonialItem.map((quote, index) => {
              const img = getImgData(quote.image);
              const isActive = index === currentIndex;
              return (
                <Image
                  key={`image-quote-carousel_image_${index}`}
                  id={`image-quote-carousel_image_${index}`}
                  src={getImgSrcWorkaround(img?.url)}
                  alt="image"
                  width={280}
                  height={332}
                  className={isActive ? 'active' : ''}
                />
              );
            })}
          </ImagesWrapper>
        </ImagesContainer>
        <GradientCircle />
        <CustomSlider
          pagination
          centeredSlides
          initialSlide={1}
          spaceBetween={28}
          slidesPerView={'auto'}
          loop
          navigation
          onSwiper={(swiper) => setCurrentIndex(swiper.realIndex)}
          onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
          slides={[
            ...testimonialItem.map((quote, index) => (
              <Quote
                key={`image-quote-carousel_quote-${index}`}
                {...quote}
                size="xl"
                byline={quote.authorRole}
                image={null}
              />
            )),
          ]}
        />
      </SectionWrap>
    </SectionWrap>
  );
}
ImageQuoteCarousel.defaultConfig = {
  rounded: false,
  colored: true,
  spaceBottom: true,
  spaceTop: true,
  marginBottom: false,
  theme: 'blue-white',
};
